export default __webpack_public_path__ + "static/media/lion-1.2ce7c43f.png";